const apiDomain = 'tjennake.com'
const cdnDomain = 'tjennake.com'

export default {
	// 系统名称
	systemName: '恩纳科内控',

	// 令牌存储名
	tokenName: 'TOKEN',

	// 验证码存储器
	verifyCodeName: 'VERIFYCODELIST',

  // 首页
  defaultURL: '/',

  // 个人主页
  homeURL: '/home',

	// 上传
	upload: {
		useCdnDomain: true,
		region: 'z1'
	},

	// 下载
	download: {
		image: `http://image.${cdnDomain}`,
		attachment: `http://attachment.${cdnDomain}`
	},

	// 请求
	request: {
		production: `https://api.${apiDomain}`,
		development: `http://api-dev.${apiDomain}`
	}
}